import $ from 'jquery'
import { toolkitUrls, pathwaysUrls } from '@/links'
import { defaultMemoryCache, ajaxCacheWrapper } from './cache'
import { getHandleRequest, getCSRFHeaders } from './request_handler'

export {
  getGoalByUuid,
  getGoalBySlug,
  getStaircaseForContent,
  shareGoal,
  unshareGoal,
  translateGoalText,
  getGoalCustomization,
  getSuperPageCustomization
}

function getGoalByUuid(uuid, params = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/goal/${uuid}`,
    data: params,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

function getGoalBySlug(slug, params = {}) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/goal/${slug}`,
    data: params,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

async function shareGoal(uuid) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: shareGoalRequest}, uuid)
}

function shareGoalRequest(uuid) {
  const baseUrl = 'library/share/goal'
  const url = `${toolkitUrls.api}/${baseUrl}/${uuid}`
  return fetch(url, {
    method: 'PUT',
    credentials: 'include',
    headers: getCSRFHeaders()
  })
}

async function unshareGoal(uuid) {
  const handleRequest = getHandleRequest()
  return handleRequest({requestFn: unshareGoalRequest}, uuid)
}

function unshareGoalRequest(uuid) {
  const baseUrl = 'library/share/goal'
  const url = `${toolkitUrls.api}/${baseUrl}/${uuid}`
  return fetch(url, {
    method: 'PUT',
    credentials: 'include',
    headers: getCSRFHeaders(),
    body: JSON.stringify({unshare: true})
  })
}

function getStaircaseForContent(uuid, standardSetCode, subject) {
  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${
      toolkitUrls.api
    }/goal/${uuid}/staircase/${standardSetCode}?group=1&subject=${encodeURIComponent(subject)}`,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

function translateGoalText(uuid, text, edited, language, profile, betaMode) {
  const body = {
    goal_uuid: uuid,
    edited: edited,
    language: language,
    content_profile: profile,
    beta_mode: betaMode
  }
  if (edited) {
    body.goal_text = text
  }
  return $.ajax({
    url: pathwaysUrls.translateGoalText,
    method: 'POST',
    contentType: 'application/json;charset=utf-8',
    xhrFields: { withCredentials: true },
    data: JSON.stringify(body)
  })
}

function getGoalCustomization(uuid, contentProfile, betaMode) {
  const params = { content_profile: contentProfile }
  if (betaMode !== undefined) {
    params.beta_mode = betaMode
  }

  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/goal/${uuid}/customization`,
    data: params,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}

function getSuperPageCustomization(uuid, contentProfile, betaMode) {
  const params = { content_profile: contentProfile }
  if (betaMode !== undefined) {
    params.beta_mode = betaMode
  }

  return ajaxCacheWrapper(defaultMemoryCache, {
    url: `${toolkitUrls.api}/super-pages/${uuid}/customization`,
    data: params,
    method: 'GET',
    contentType: 'json',
    xhrFields: { withCredentials: true }
  })
}
